import React from 'react';
import classNames from 'classnames';

export const DataDisplay = props => {
	const { className, label, data } = props;
	const elementCls = classNames('common-ui-data-display', className);

	return (
		<div className={elementCls}>
			{label && (
				<div className="label-container">
					<div data-qa="ui-label" {...{ dataqa: 'ui-label' }}>
						{label}
					</div>
				</div>
			)}
			<div className="data-display-container">{data}</div>
		</div>
	);
};
